export default __webpack_public_path__ + "static/media/0_Intro.66a5c589.mp4";